export default __webpack_public_path__ + "static/media/IMG_9790.e02ceeb4.jpg";